import React from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '../contexts/ThemeContext';
export function ThemedToaster() {
  const {
    resolved
  } = useTheme();
  return <Toaster theme={resolved} position="top-center" toastOptions={{
    style: {
      fontFamily: 'Nunito, ui-sans-serif, system-ui, sans-serif',
      borderRadius: 20
    }
  }} data-id="element-768" data-mp="2h05fif15zehd" />;
}